import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { Advertisement } from '../components/Advertisement';
import { useReactGptLoader } from '../hooks/use-react-gpt-loader';

window.React = React;

export const AdvertisementProvider = ({ store, data }) => {
    const reactGptLoaded = useReactGptLoader();

    useEffect(() => {
        if (data.enableDebug) {
            console.info(
                `[AdvertismentProvider "${data.advertName}"] : reactGptLoaded`,
                reactGptLoaded,
                data
            );
        }
    }, [reactGptLoaded]);

    return (
        <Provider store={store}>
            {reactGptLoaded && <Advertisement {...data} />}
        </Provider>
    );
};

AdvertisementProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
